var map = {
	"./converge.png": 318,
	"./img-1.png": 22,
	"./img-2.png": 23,
	"./img-3.png": 24,
	"./img-4.png": 319,
	"./img-5.png": 21,
	"./img-6.gif": 320,
	"./logo_64264.png": 321,
	"./paradise_challenge.png": 322,
	"./pbpLogo_transparentBg.png": 323
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 317;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos ^\.\/.*$
// module id = 317
// module chunks = 2